import { Injectable } from '@angular/core';
import { IFactoryRepository, IModelFactory } from './factory.interface';

@Injectable({ providedIn: 'root' })
export class FactoryRepository {
  private readonly models: IFactoryRepository = {};

  public getModel(modelName: string): IModelFactory {
    return this.models[modelName];
  }
}
